import React, {useCallback, useMemo, useState} from 'react';
import './LandingNotification.less';
import {mediaSizes} from '../../../configs/media';
import {t} from '../../../services/i18nHandler';

function LandingNotification({
  type = '',
  position = '',
  title,
  text,
  btnText,
  onClick,
  windowWidth,
}) {
  const [show, setShow] = useState(false);

  const onCloseClick = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    setShow(false);
  }, []);

  const isMobile = useMemo(() => (mediaSizes.sm >= windowWidth), [windowWidth]);

  return (
    <div
      role="button"
      className={`landing-notification ${position} ${show ? 'active' : ''}`}
      onMouseEnter={!isMobile ? () => setShow(true) : null}
      onMouseLeave={!isMobile ? () => setShow(false) : null}
      onClick={() => setShow(true)}
    >
      <div className={`landing-notification_icon ${type}`} />
      <div className="landing-notification_content">
        <div className="landing-notification_title">
          {title}
        </div>
        <div className="landing-notification_text">
          {text}
        </div>
        <div className="landing-notification_button_wrap">
          <button
            type="button"
            onClick={onClick}
            className="landing-notification_button"
          >
            {btnText}
          </button>
        </div>
        {isMobile && (
          <div className="landing-notification_button_wrap">
            <button
              type="button"
              className="landing-notification_close"
              onClick={onCloseClick}
            >
              {t('buttons.close')}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}


LandingNotification.propTypes = {

};

export default LandingNotification;
